/**
 * `localStorage` 기반 `StorageAdapter`.
 *
 * 접근을 감싸는 이유는 `packages/bloom-receiver-sdk` 의 같은 어댑터와 같다 — 사파리 프라이빗 모드나
 * 서드파티 컨텍스트에서 `localStorage` 접근이 **예외를 던진다.**
 *
 * 다만 **여기서의 대가는 리시버보다 크다.** 저장소를 못 쓰면 `deviceId` 가 실행마다 바뀌고,
 * 그러면 (1) 매번 새 기기로 등록돼 가구에 유령 기기가 쌓이고 (2) QR 설치 ref 를 보관할 수
 * 없어 Deferred 복원이 성립하지 않는다. 그래도 던지지는 않는다 — 저장소가 없다고 상품
 * 화면까지 못 볼 이유는 없고, 그 상태는 `Tv2mInitResult` 의 `firstRun` 이 늘 `true` 인
 * 것으로 화면에 드러난다.
 */
export class LocalStorageAdapter {
    get(key) {
        try {
            return localStorage.getItem(key);
        }
        catch {
            return null;
        }
    }
    set(key, value) {
        try {
            localStorage.setItem(key, value);
        }
        catch {
            // 무시한다. 위 주석 참조.
        }
    }
    remove(key) {
        try {
            localStorage.removeItem(key);
        }
        catch {
            // 무시한다.
        }
    }
}
//# sourceMappingURL=local-storage.js.map